<template>
  <v-app>
    <title v-if="pageTitle">{{ pageTitle }}</title>
    <OnexMain />
  </v-app>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { OnexMain } from '@primerica/onex-ui-lib';
import { Translations } from '@/i18n/models';
import PegaApiStore from '@/stores/pegaApi.store';
import { mapState } from 'pinia';
export default defineComponent({
  name: 'AppView',
  components: {
    OnexMain,
  },
  data() {
    return {
      Translations,
    };
  },
  computed: {
    ...mapState(PegaApiStore, ['pageTitle']),
  },
});
</script>
